//import i18n from "i18next";

//path to cross origin (Java API)
//const pathToCrossOrigin = "http://localhost:8080/apiPoetryCorpus/";
//const pathToCrossOrigin = "http://94.130.181.51:8099/apiPoetryCorpus/";
//const pathToCrossOrigin = "http://94.130.181.51:8080/RuPoetryCorpusAPI/apiPoetryCorpus";
//for apalladio.org:
const pathToCrossOrigin = "/poetrycorpus-api";
//const pathToCrossOrigin = "http://localhost:8080/RussianPoetryCorpus_API_war/apiPoetryCorpus";
//languages:
const languages = ["en", "de", "es", "fr", "it", "ru", "uk"];
const languagesNames = [
  "English",
  "Deutsch",
  "Español",
  "Français",
  "Italiano",
  "Русский",
  "Українська",
];

function fillAuthorsBook(intAuthor) {
  const books = new Map();
  if (intAuthor === 7) {
    //Бродский
    books.set(0, "Без фильтра");
    books.set(31, "1957 - 1963гг. и с неопределенной датой");
    books.set(32, "1964 - 1968гг.");
    books.set(33, "1969 - 1977гг.");
    books.set(34, "1978 - 1986гг.");
    books.set(35, "1987 - 1995гг.");
  } else if (intAuthor === 8) {
    //Рейн
    books.set(0, "Без фильтра");
    books.set(36, "Из сборника издания Б.Тайгина (1964)");
    books.set(37, "Из антологии 'У Голубой Лагуны'");
    books.set(38, "Новый мир №3 1993. Сорок четыре.");
    books.set(39, "Имена мостов (из Избранного 1993г.)");
    books.set(40, "Береговая полоса  (из Избранного 1993г.)");
    books.set(41, "Темнота зеркал  (из Избранного 1993г.)");
    books.set(42, "Предсказание  (из Избранного 1993г.)");
    books.set(43, "Новый мир №6 1994. Сапожок. Из книги итальянских стихов.");
    books.set(44, "Арион №4 1995. Голоса. Стихи.");
    books.set(45, "Новый мир №5 1995. Обратный счет.");
    books.set(46, "Новый мир №2 1996. Она вошла в каком-то темном платье.");
    books.set(47, "Новый мир №11 1996. Солнечные часы.");
    books.set(48, "Арион №4 1997. Лишь бы вернуться.");
    books.set(49, "Новый мир №4 1997. На золотом пляже.");
    books.set(50, "Новый мир №9 1997. Мы правим бал.");
    books.set(51, "Новый мир №2 1998. Через окуляр.");
    books.set(52, "Арион №2 2000. Голоса.");
    books.set(53, "Арион №2 2001. Римлянин и скиф.");
    books.set(54, "Звезда №11 2001. Стихи.");
    books.set(55, "Арион №2 2002. Голоса.");
    books.set(56, "Вестник Европы №4 2002. Трисмегист.");
    books.set(57, "Знамя №5 2002. Гранёный алмаз.");
    books.set(58, "Новый мир №5 2002. Прицел.");
    books.set(59, "Арион №4 2003. Голоса.");
    books.set(60, "Знамя №11 2003. Старая Англия, Новая Англия.");
    books.set(61, "Континент №117 2003. Юго-Запад.");
    books.set(62, "Новый мир №4 2004. Утешительный приз.");
    books.set(63, "Знамя №5 2004. После Илиады.");
    books.set(64, "Звезда №6 2004. Набережная.");
    books.set(65, "Знамя №12 2004. Грамотный львенок.");
    books.set(66, "Новый мир №2 2005. Вершина света.");
    books.set(67, "Новый мир №2 2006. Батум.");
    books.set(
      68,
      "Дружба народов №2 2009. Новогодняя оттепель в Зеленогорске."
    );
    books.set(69, "Знамя №1 2013. Вдоль времени.");
    books.set(70, "Новый мир №5 2013. Парк мертвых и живых.");
    books.set(71, "Знамя №12 2013. Соль из солеварен.");
    books.set(72, "Новый мир №1 2014. Сталь Авраама.");
  } else if (intAuthor === 9) {
    //Набоков
    books.set(0, "Без фильтра");
    books.set(73, "Горний путь");
    books.set(74, "Гроздь");
    books.set(75, "Из книги 'Возвращение Чорба'");
    books.set(76, "Из книги 'Poems and Problems'");
    books.set(77, "Стихи из рассказов и романов. 1");
    books.set(78, "Стихи из рассказов и романов. 2");
    books.set(79, "Стихотворения, не входившие в прижизненные сборники");
  } else if (intAuthor === 10) {
    //Ходасевич
    books.set(0, "Без фильтра");
    books.set(80, "В моей стране");
    books.set(81, "Кузина");
    books.set(82, "Звезда над пальмой");
    books.set(83, "Лары");
    books.set(84, "Пленные шумы");
    books.set(85, "Путем зерна");
    books.set(86, "Тяжелая лира");
    books.set(87, "Европейская ночь");
  } else if (intAuthor === 11) {
    //Гумилев
    books.set(0, "Без фильтра");
    books.set(88, "Электронное собрание сочинений, порция 1");
    books.set(89, "Электронное собрание сочинений, порция 2");
    books.set(90, "Электронное собрание сочинений, порция 3");
    books.set(91, "Альбом М.М.Маркс. 1903");
    books.set(92, "Путь конквистадоров. 1905");
    books.set(93, "Романтические цветы. 1908");
    books.set(94, "Жемчуга. 1910");
    books.set(95, "Чужое небо. 1912");
    books.set(96, "Колчан. 1916");
    books.set(97, "Костер. 1918");
    books.set(98, "Фарфоровый павильон. 1918");
    books.set(99, "Огненный столп. 1921");
    books.set(100, "Шатер. 1921");
  } else if (intAuthor === 12) {
    //Мандельштам
    books.set(0, "Без фильтра");
    books.set(101, "Стихи 1906-1921. Том 1 собрания сочинений в 4-х томах");
    books.set(102, "Стихи 1921-1929. Том 2 собрания сочинений в 4-х томах");
    books.set(103, "Стихи 1930-1937. Том 3 собрания сочинений в 4-х томах");
  } else if (intAuthor === 13) {
    //Гораций
    books.set(0, "Без фильтра");
    books.set(104, "Оды. Книга 1");
    books.set(105, "Оды. Книга 2");
    books.set(106, "Оды. Книга 3");
    books.set(107, "Оды. Книга 4");
    books.set(108, "Послания. Книга 1");
    books.set(109, "Послания. Книга 2");
    books.set(110, "Сатиры. Книга 1");
    books.set(111, "Сатиры. Книга 2");
    books.set(112, "Эподы");
    books.set(113, "Юбилейный гимн");
    books.set(114, "Наука поэзии");
  }
  else if (intAuthor === 14) {
    //Дашевский
    books.set(0, "Без фильтра");
    books.set(116, "ДУМА ИВАН-ЧАЯ");
    books.set(117, "Стихотворения и переводы");
  }
  return books;
}

function isYearsInAuthorsBoos(intAuthor) {
  if (intAuthor === 7) {
    //only Brodsky has
    return true;
  }
  return false;
}

function infoAuthorsCorpus(intAuthor) {
  const info = new Map();
  if (intAuthor === 7) {
    //Бродский
    info.set("NumberOfPoems", 685);
    info.set("NumberOfLines", 31316);
  } else if (intAuthor === 8) {
    //Рейн
    info.set("NumberOfPoems", 428);
    info.set("NumberOfLines", 14667);
  } else if (intAuthor === 9) {
    //Набоков
    info.set("NumberOfPoems", 451);
    info.set("NumberOfLines", 11799);
  } else if (intAuthor === 10) {
    //Ходасевич
    info.set("NumberOfPoems", 179);
    info.set("NumberOfLines", 3736);
  } else if (intAuthor === 11) {
    //Гумилев
    info.set("NumberOfPoems", 569);
    info.set("NumberOfLines", 15700);
  } else if (intAuthor === 12) {
    //Мандельштам
    info.set("NumberOfPoems", 664);
    info.set("NumberOfLines", 11287);
  } else if (intAuthor === 13) {
    //Гораций
    info.set("NumberOfPoems", 160);
    info.set("NumberOfLines", 7807);
  } else if (intAuthor === 14) {
    //Дашевский
    info.set("NumberOfPoems", 96);
    info.set("NumberOfLines", 1823);
  }
  return info;
}

const authors = new Map();
authors.set(7, "Бродский Иосиф");
authors.set(13, "Квинт Гораций Флакк");
authors.set(11, "Гумилев Николай");
authors.set(14, "Дашевский Григорий");
authors.set(12, "Мандельштам Осип");
authors.set(9, "Набоков Владимир");
authors.set(8, "Рейн Евгений");
authors.set(10, "Ходасевич Владислав");

const poemsMeters = [
  "Без фильтра",
  "Хореи",
  "Ямбы",
  "Дактили",
  "Амфибрахии",
  "Анапесты",
  "Верлибры",
  "Хориямбы",
  "Логаэды",
  "Смешанные размеры",
  "Тонические",
  "Пентоны",
  "Гекзаметры и подобные",
  "Асклепиадова строфа",
  "1-ая Асклепиадова строфа",
  "2-я Асклепиадова строфа",
  "3-я Асклепиадова строфа",
  "4-я Асклепиадова строфа",
  "5-я Асклепиадова строфа",
  "1-ая Архилохова строфа",
  "2-я Архилохова строфа",
  "3-я Архилохова строфа",
  "Сапфическая строфа",
  "Большая сапфическая строфа",
  "Алкеева строфа",
  "Гиппонактова строфа",
];

const lineMeters = [
  "Без фильтра",
  "Хорей",
  "Ямб",
  "Дактиль",
  "Амфибрахий",
  "Анапест",
  "Пентон",
  "Неопределен",
];

const stropheType = [
  "Без фильтра",
  "Отсутствует",
  "Двустишие",
  "Трехстишие",
  "Четверостишие",
  "Пятистишие",
  "Шестистишие",
  "Семистишие",
  "Восьмистишие",
  "Девятистишие",
  "Десятистишие",
  "Одиннадцатистишие",
  "Двенадцатистишие",
  "Тринадцатистишие",
  "Четырнадцатистишие",
];

const rhymeTypeInStrophe = [
  "Без фильтра",
  "Отсутствует",
  "Перекрестная",
  "Парная",
  "Охватная",
  "Тройная",
  "Скользящая",
  "Затянутая",
  "Сложная",
  "Нерегулярная споради",
  "Нерегулярная вольная",
];

const solidForms = ["Без фильтра", "Сонет"];

const rhymeKind = [
  "Без фильтра",
  "Отсутствует",
  "Открытая",
  "Закрытая",
  "Закрыто открытая",
  "Открыто закрытая",
];

const grammaticalFormOfRhyme = [
  "Без фильтра",
  "Отсутствует",
  "Существительное",
  "Местоимение",
  "Глагол",
  "Причастие",
  "Деепричастие",
  "Прилагательное",
  "Наречие",
  "Числительное",
  "Вводное слово",
  "Служебное",
  "Фразеологизм",
];

const sortOfRhymes = [
  "Без фильтра",
  "Отсутствует",
  "Точная",
  "Ассонанс",
  "Диссонанс",
  "Тавторифма",
  "Составная рифма",
  "Корневая рифма",
  "Омонимическая рифма",
];

class CommonConstants {
  getPathToCrossOrigin(params) {
    return pathToCrossOrigin;
  }

  /* buildLanguageOptions() {
    let options = [];

    const indLanguage = languages.indexOf(i18n.language);
    if (indLanguage >= 0) {
      options.push(
        <option
          value={languages[indLanguage]}
          id={languages[indLanguage]}
          key={languages[indLanguage]}
        >
          {languagesNames[indLanguage]}
        </option>
      );
    }

    for (let ind = 0; ind < languages.length; ind++) {
      if (ind !== indLanguage) {
        options.push(
          <option
            value={languages[ind]}
            id={languages[ind]}
            key={languages[ind]}
          >
            {languagesNames[ind]}
          </option>
        );
      }
    }
    return options;
  }
 */
  getLanguages() {
    return languages;
  }

  getLanguagesNames() {
    return languagesNames;
  }

  getAuthors() {
    return authors;
  }
  getAuthorsBooks(intAuthor) {
    return fillAuthorsBook(intAuthor);
  }

  getIsYearInAuthorsBooks(intAuthor) {
    return isYearsInAuthorsBoos(intAuthor);
  }

  getInfoAuthorsCorpus(intAuthor) {
    return infoAuthorsCorpus(intAuthor);
  }

  getPoemsMeters() {
    return poemsMeters;
  }

  getLinesMeters() {
    return lineMeters;
  }

  getStropheType() {
    return stropheType;
  }

  getRhymeTypeInStrophe() {
    return rhymeTypeInStrophe;
  }

  getSolidForms() {
    return solidForms;
  }

  getRhymeKind() {
    return rhymeKind;
  }

  getGrammaticalFormOfRhyme() {
    return grammaticalFormOfRhyme;
  }

  getSortOfRhymes() {
    return sortOfRhymes;
  }
}

export default new CommonConstants();
